import { markupTemplateLang } from "./shared"

markupTemplateLang("latte", {
	block: ["{*", "*}"],
})
